// Single source of truth for admin role constants. Sidebar (Layout.tsx)
// and route-level role guard (App.tsx via <RoleGuard>) both import from
// here so the visibility filter on the menu stays aligned with the
// redirect-on-direct-navigation guard. The server enforces the same
// role array via `requireRole(...)` in `backend/worker/src/lib/middleware.ts`.
//
// Canonical access matrix lives in `docs/admin/admin-users.md`.

export type AdminRole = 'super_admin' | 'operations' | 'accounting' | 'marketing'

export const ALL: AdminRole[] = ['super_admin', 'operations', 'accounting', 'marketing']
export const OPS: AdminRole[] = ['super_admin', 'operations']
export const OPS_ACCT: AdminRole[] = ['super_admin', 'operations', 'accounting']
export const OPS_MKT: AdminRole[] = ['super_admin', 'operations', 'marketing']
export const SUPER: AdminRole[] = ['super_admin']
